import type { Drawing } from '@manudev/model';
import { create } from 'zustand';

export type DrawingMode = 'plan' | 'section';
export type SectionAxis = 'x' | 'z';

// What the visitor asked for and what the store worker last drew for it.
interface DrawingsState {
  mode: DrawingMode;
  storeyId: number | null;
  axis: SectionAxis;
  // where the section sits along its axis, 0 to 1 across the building
  at: number;
  drawing: Drawing | null;
  // the request the drawing answers, and its name for the header and the file
  drawn: string | null;
  title: string;
  busy: boolean;
  error: string | null;
  hoveredRoom: string | null;
  setMode: (mode: DrawingMode) => void;
  setStorey: (storeyId: number) => void;
  setAxis: (axis: SectionAxis) => void;
  setAt: (at: number) => void;
  hoverRoom: (globalId: string | null) => void;
}

export const useDrawingsStore = create<DrawingsState>((set) => ({
  mode: 'plan',
  storeyId: null,
  axis: 'z',
  at: 0.5,
  drawing: null,
  drawn: null,
  title: '',
  busy: false,
  error: null,
  hoveredRoom: null,
  setMode: (mode) => set({ mode, hoveredRoom: null }),
  setStorey: (storeyId) => set({ storeyId, hoveredRoom: null }),
  setAxis: (axis) => set({ axis }),
  setAt: (at) => set({ at: Math.min(1, Math.max(0, at)) }),
  hoverRoom: (hoveredRoom) => set({ hoveredRoom }),
}));
